import { Button, Row, Tooltip, Modal, message, Pagination, Input } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderSection from "../components/HeaderSection.tsx";
import PreTable from "../components/PreTable.tsx";
import { searchTableColumns } from "../config/data.tsx";
import ReturnArrow from '../assets/svg/returnArrow.svg'
import {FaRegSave} from "react-icons/fa";
import {checkUserPermissions,initialPermissions,} from "../lib/userPermissions.ts";
import Permissions from '../lib/userPermissions.ts'
import TechModal from "../router/TechModal.tsx";
import CombinedDropdown from "../components/CombinedDropdown.tsx";
import { apSaveEnrichment } from "../lib/apSaveEnrichment.ts"
import { apEnrichment } from "../lib/apEnrichment.ts";
import { getUserCreditsAp } from "../lib/getUserCreditsAp.ts";
import CompanySumary from "../components/SearchResultTable/CompanySummary.tsx";
import EnrichmentModal from "../components/SearchResultTable/EnrichmentModal.tsx";
import { usePostHog } from "posthog-js/react";
import { deleteLead } from "../lib/deleteLead.ts";
import { apGetEnrichment } from "../lib/apGetEnrichment.ts";
import LeadCard from "../components/SearchResultTable/LeadCard.tsx";
import EnrichCompaniesIcon from '../assets/svg/enrichCompaniesIcon.svg'
import EnrichPeopleIcon from '../assets/svg/enrichPeopleIcon.svg'
import { CiSearch } from "react-icons/ci";

export interface SearchResultData {
  cnpj_completo: string;
  razao_social: string;
  nome_fantasia: string;
  uf: string;
  municipio: string;
  bairro: string;
  cep: string;
  logradouro: string;
  cnae_principal: string;
  porte: string;
  email: string;
  dominio_email: string;
  telefone: string;
  facebook: string;
  instagram: string;
  linkedin: string;
  whatsapp: string;
  socios: string;
  capital_social: string;
  mei: string;
  dados_empresa?: object[];
  dados_pessoas?: object[];
  qtd_estabelecimentos?: number;
  qtd_socios?: number;
  renda_doc_por_pessoa?: number;
}

interface LeadToDelete{
  razao_social?:string,
  nome_lista:string,
  cnpj:string
}

interface SearchResultsPageProps {
  receivedData?: SearchResultData[];
  individualSearchTable?: boolean;
  pathProp?: string;
}

export const porteEmpresa: Record<string, string> = {
  "00": "Não Informado",
  "01": "Micro Empresa",
  "03": "Empresa de Pequeno Porte",
  "05": "Demais",
};


export const formatCep = (cep: string) => {
  if (!cep) return cep;
  return cep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
};
export const formatPhone = (phone: string) => {
  if (!phone) return phone;

  return phone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3");
};
export const formatCnpj = (cnpj: string) => {
  if (!cnpj) return cnpj;
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5",
  );
};
export const formatCnae = (cnae: string) => {
  if (!cnae) return cnae;
  return cnae.replace(/^(\d{4})(\d)(\d{2})$/, "$1-$2/$3");
};

export const cleanQuery = (query: string) => (
   query
    .normalize("NFD")
    .replace(/[^a-zA-Z0-9 .,@$/()-]/g, "")
    .toLowerCase()
)

const SearchResultsPage: React.FC<SearchResultsPageProps> = ({receivedData,individualSearchTable, pathProp}) => {
  const [isTechModalVisible, setIsTechModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<SearchResultData | null>(null,);
  const [modalLoading, setModalLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState<Record<string, any> | null>(null,);
  const [userPermissions, setUserPermissions] = useState<Permissions>(initialPermissions);
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state as { resultData?: SearchResultData[] };
  const [resultData, setResultData] = useState<SearchResultData[]>(
    locationState ? locationState.resultData ?? [] : []
  );
  const [individualSearchData, setIndividualSearchData] = useState<SearchResultData[] | undefined>([]);
  const { id } = location.state || { resultData: "" }; // Recebe os dados da localização
  const path = pathProp ?? location.state?.path ?? "";

  const [enrichmentModalVisible, setEnrichmentModalVisible] = useState<boolean>(false)
  const [domainToEnrich, setDomainToEnrich] = useState<string | undefined>(undefined)
  const [selectedLevels, setSelectedLevels] = useState<string[]>([])
  const [enrichmentQuantity, setEnrichmentQuantity] = useState<number>(10)
  const [companyLoading, setCompanyLoading] = useState<boolean>(false)
  const [actualPage, setActualPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [actualPageSize, setActualPageSize] = useState<number>(pageSize)

  const [enrichingEmploee, setEnrichingEmploee] = useState<string[] | undefined>(undefined)
  const [enrichmentResultKey, setEnrichMentResultKey] = useState<number>(Math.random())
  const [enrichAllResultsLoading, setEnrichAllResultsLoading] = useState<boolean>(false)
  const [enrichPeopleLoading, setEnrichPeopleLoading] = useState<boolean>(false)
  const [apolloKey,setApolloKey] = useState<number>(Math.random())

  const [haveEnrichmentCredits, setHaveEnrichmentCredits] = useState<boolean>(false)
  const [requestErichmentCreditsKey, setRequestErichmentCredtisKey] = useState<number>(Math.random())

  const [pagePeopleEnrichmentModalVisible, setPagePeopleEnrichimentModalVisible] = useState<boolean>(false)
  const [pagePeopleCreditsCost, setPagePeopleCreditsCost] = useState<number>(0) 
  const posthog = usePostHog();

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false)
  const [leadToDelete, setLeadToDelete] = useState<LeadToDelete | undefined>(undefined)
  const [deleteModalLoading, setDeleteModalLoading] = useState<boolean>(false)

  const [searchQuery, setSearchQuery] = useState<string>('')
  const [filteredData, setFilteredData] = useState<SearchResultData[]>(resultData)



  useEffect(()=>{
    console.log(searchQuery);
    setFilteredData(resultData.filter(lead=>(
      cleanQuery(lead.razao_social).includes(searchQuery) ||
      cleanQuery(lead.nome_fantasia).includes(searchQuery) || 
      cleanQuery(formatCnpj(lead.cnpj_completo)).includes(searchQuery) ||
      cleanQuery(lead.uf).includes(searchQuery) ||
      cleanQuery(lead.municipio).includes(searchQuery) ||
      cleanQuery(`${lead.logradouro}, ${lead.bairro}, ${formatCep(lead.cep)}`).includes(searchQuery) ||
      cleanQuery(porteEmpresa[lead.porte]).includes(searchQuery) ||
      cleanQuery(`R$ ${lead.capital_social}`).includes(searchQuery) ||
      cleanQuery(formatCnae(lead.cnae_principal)).includes(searchQuery) ||
      cleanQuery(lead.email).includes(searchQuery) ||
      cleanQuery(formatPhone(lead.telefone)).includes(searchQuery) ||
      cleanQuery(`${lead.socios.split(',').map((socio,index)=>(index < 3 ? socio: ''))}`).includes(searchQuery)      
    )))
  },[searchQuery])

  useEffect(() => {
    const fetchUserRole = async () => {
      const userPermission = await checkUserPermissions();
      setUserPermissions(userPermission);
    };

    fetchUserRole();
  }, []);

useEffect(() => {
  if (receivedData && receivedData.length) {
    setIndividualSearchData(receivedData);
  } else {
    const raw = localStorage.getItem("leadResults");
    if (raw) {
      try {
        const saved: SearchResultData[] = JSON.parse(raw);
        setResultData(saved);
      } catch {
        console.error("Não foi possível fazer parse de leadResults");
      }
    }
  }
}, [receivedData]);


  useEffect(()=>{
    getUserCreditsAp().then(response=>{
     if (response > 0) setHaveEnrichmentCredits(true)
    else setHaveEnrichmentCredits(false)
      
    })
  },[requestErichmentCreditsKey])

  const handleDeleteLead = ()=>{
    if(!leadToDelete) return
    setDeleteModalLoading(true)
    deleteLead(leadToDelete.nome_lista,leadToDelete.cnpj).then(response=>{
      if(response.statusCode === 200){
        message.success(response.body)
        const updated = resultData.filter(
          l => l.cnpj_completo !== leadToDelete.cnpj
        );
        setResultData(updated);
        localStorage.setItem("leadResults", JSON.stringify(updated));
        navigate(location.pathname, {
          state: { resultData: updated },
          replace: true
        });
      }
      else message.error(response.body)

      setIsDeleteModalVisible(false)
      setDeleteModalLoading(false)
      setLeadToDelete(undefined)
    })
  }

  const goBackButton = () => {
    return (
        <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
          <ReturnArrow />
          <Link
          style={{ color: '#33EA89' }}
          onClick={() => {
            posthog.capture('nova_busca_botao');
            goBack();
          } }
          to={""}
        >
          Nova Busca
        </Link>
      </div>
    );
  };

  const companiesEnrichment = () => {
    return (
        <Button
          disabled={!userPermissions.ops_enriquecimento || !haveEnrichmentCredits || !resultData
            .slice((actualPage - 1) * pageSize, (actualPage - 1) * pageSize + pageSize)
            .filter(
              (d): d is SearchResultData & { dominio_email: string } =>
                d.dominio_email ? d.dominio_email.length > 0 : false
            ).length}
          type="primary"
          size="large"
          icon={<EnrichCompaniesIcon/>}
          className="submitButton"
          style={{
            fontSize:'small',
            width: "200px",
            padding: "14px",
            margin: "32px 0",
          }}
          onClick={()=>{
            posthog.capture('enriquecer_empresa_botao');
            setEnrichmentModalVisible(true)
          }}
        >
          Enriquecer empresas
        </Button>
    );
  };

  const peopleEnrichment = () => {
    return (
        <Button
          loading={enrichPeopleLoading}
          disabled={ !userPermissions.ops_enriquecimento || !resultData
            .slice((actualPage - 1) * pageSize, (actualPage - 1) * pageSize + pageSize)
            .filter(
              (d: { dados_empresa: string | any[]; }): d is SearchResultData & { dados_empresa: unknown[] } =>
                Array.isArray(d.dados_empresa) && d.dados_empresa.length > 0
            ).length || !haveEnrichmentCredits}
          type="primary"
          size="large"
          icon={<EnrichPeopleIcon />}
          className="submitButton"
          style={{
            fontSize:'small',
            padding: "14px",
            margin: "32px 0",
          }}
          onClick={()=>{
            posthog.capture('enriquecer_pessoa_botao');
            const idsEmpresa = new Set<string>();
            const idsPessoas = new Set<string>();
            const lowerIndex = (actualPage - 1) * pageSize;
            const upperIndex = lowerIndex + pageSize;
            const slice = (searchQuery.length ? filteredData : resultData)
            .slice(lowerIndex, upperIndex)
            .filter(
              (d): d is SearchResultData & { dados_empresa: unknown[] } =>
                Array.isArray(d.dados_empresa) && d.dados_empresa.length > 0
            );
            for (const item of slice) {
              if (item.dados_empresa) {
                
                for (const emp of item.dados_empresa) {
                  if(emp.email_status === "verified")
                  idsEmpresa.add(emp.id);
                }
              }
              if (item.dados_pessoas) {
                for (const pes of item.dados_pessoas) {
                  idsPessoas.add(pes.id);
                }
              }
            }
            
            const resultado: string[] = [];
            for (const id of idsEmpresa) {
              if (!idsPessoas.has(id)) {
                resultado.push(id);
              }
            }
                        
            if (resultado.length === 0) {
              message.error("Nenhuma empresa disponivel para enriquecimento");
              return;
            } else {
              setPagePeopleCreditsCost(resultado.length)
            }
            setPagePeopleEnrichimentModalVisible(true)
          }}
        />

    );
  };

  const saveEnrichmentData = ()=>{
    return (
      <div className="btn-go-back">
        <Button
          disabled={!resultData
            .slice((actualPage - 1) * pageSize, (actualPage - 1) * pageSize + pageSize)
            .filter(
              (d): d is SearchResultData & { dados_empresa: unknown[] } =>
                Array.isArray(d.dados_empresa) && d.dados_empresa.length > 0
            ).length}
          type="primary"
          size="large"
          icon={<FaRegSave />}
          className="form-button"
          style={{
            fontSize:'small',
            width: "200px",
            padding: "14px",
            margin: "32px 0",
          }}
          onClick={()=>{
            posthog.capture('salvar_enriquecimento_botao');
            const lowerIndex = (actualPage - 1) * pageSize;
            const upperIndex = lowerIndex + pageSize;

            const slice = resultData
              .slice(lowerIndex, upperIndex)
              .filter(
                (d): d is SearchResultData & { dados_empresa: unknown[] } =>
                  Array.isArray(d.dados_empresa) && d.dados_empresa.length > 0
              );

            apSaveEnrichment(path, slice).then(
               response => {
                 if (response.message) {
                  console.log(response);
                   message.error("Erro ao salvar dados!");
                 } else {
                   message.success("Dados salvados com sucesso!")
                 }
                 console.log(response)
               }
             )
          }}
        >
          Salvar Enriquecimento
        </Button>
      </div>
    );
  }


  const enrichPerson = async (id: string | string[]) => {
    const normalizedId = typeof id === 'string' ? [id] : id;
  
    let validIds = normalizedId;
  
    if (selectedRecord) {
      validIds = normalizedId.filter(idValue => {
        const company = selectedRecord.dados_empresa?.find(emp => emp.id === idValue);
        return company && company.email_status === "verified";
      });
    } else {
      validIds = normalizedId.filter(idValue => {
        for (const item of resultData) {
          if (!item.dados_empresa) continue;
  
          const company = item.dados_empresa.find(emp => emp.id === idValue);
          if (company && company.email_status === "verified") {
            return true;
          }
        }
        return false;
      });
    }
  
    if (validIds.length === 0) {
      message.error("Nenhum contato com e-mail verificado disponível para enriquecimento");
      setEnrichPeopleLoading(false);
      setEnrichingEmploee(undefined);
      return;
    }
  
    try {
      const responseId = await apEnrichment(validIds, false, localStorage.getItem("leadPath") ?? '');

      let loop = true
      
      const pollEnrichment = async () => {
        while (loop) {
          const response = await apGetEnrichment(responseId);
  
          if (response.message === "Enriquecimento não finalizado.") {
            console.log("Em processamento, aguardando 5 segundos...");
            await new Promise(resolve => setTimeout(resolve, 5000));
            continue;
          }
          else{
            loop = false
          }
  
          return response;
        }
      };
  
      const response = await pollEnrichment();
  
      if (!Array.isArray(response) && response?.message) {
        setEnrichingEmploee(undefined);
        message.error(response.message);
        setEnrichPeopleLoading(false);
        return;
      } else if (Array.isArray(response)) {
        if (selectedRecord) {
          selectedRecord.dados_pessoas = selectedRecord.dados_pessoas ?? [];
          response.forEach((item) => {
            selectedRecord.dados_pessoas.push({
              nome: item.name,
              email: item.email,
              linkedin_url: item.linkedin_url,
              photo_url: item.photo_url,
              titulo: item.title,
              id: item.id,
            });
          });
        } else {
          for (const item of resultData) {
            if (!item.dados_empresa || item.dados_empresa.length === 0) {
              continue;
            }
  
            const companyIds = item.dados_empresa.map(company => company.id);
  
            const matchingPeople = response.filter(person =>
              companyIds.includes(person.id)
            );
  
            for (const person of matchingPeople) {
              item.dados_pessoas = [
                ...(item.dados_pessoas || []),
                { nome: person.nome, email: person.email, linkedin_url: person.linkedin_url, photo_url: person.photo_url, titulo: person.title, id: person.id }
              ];
            }
          }
        }
        setApolloKey(Math.random());
        // Persistir no localStorage para sobreviver a F5
        localStorage.setItem("leadResults", JSON.stringify(resultData));
        message.success("Enriquecimento realizado com sucesso");
      } else {
        message.error("Erro no enriquecimento!");
      }
    } catch (error) {
      message.error("Erro ao processar enriquecimento");
    } finally {
      setEnrichPeopleLoading(false);
      setEnrichingEmploee(undefined);
    }
  };
  
  const goBack = () => {
    navigate("/painel/geracao-leads");
  };
  
  const renderSection = () => {
    return (
      <div className="table-wrapper">
        {individualSearchTable ? 
        <div style={{display:'flex', flexDirection:'row', justifyContent: 'flex-end', marginBottom: '1em'}}>
          <div style={{ maxWidth: '30vh'}}>
            <CombinedDropdown />
          </div>
        </div>
        : 
          <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                <Input
                  type="text"
                  className="resultTableSearch"
                  placeholder="Pesquisar"
                  onChange={(e)=>{setSearchQuery(cleanQuery(e.target.value))}}
                  onBlur={() =>
                    posthog.capture("pesquisa_search_result_table")
                  }
                  suffix={searchQuery.length ? <></> : <CiSearch/>}
                  allowClear
                ></Input>
            </div>
            <div style={{display:'flex', alignItems:'center', justifyContent: 'space-between'}}>
              <div style={{width: '30vh'}}>
              </div>
              <div>
                <span>{companiesEnrichment()}</span>
                <span style={{marginLeft:'1em'}}><Tooltip title="Enriquecer pessoas">{peopleEnrichment()}</Tooltip></span>
              </div>
              <div style={{display:'flex', flexDirection:'row', justifyContent: 'flex-end', width: '30vh'}}>
                <CombinedDropdown />
                <span style={{marginLeft:'1em'}}>
                  <PreTable
                    total={resultData.length}
                    dataSource={resultData}
                    columns={searchTableColumns}
                    id={id}
                    path={path}
                  />
                </span>
              </div>
            </div>
          </div>
        }
        {individualSearchTable ? (
          <></>
        ) : (
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
          </Row>
        )}
        <div>
          {(
            individualSearchTable 
              ? individualSearchData ?? []
              : 
              searchQuery.length ?
                filteredData 
              :
                resultData
          )
            .slice((actualPage - 1) * pageSize, actualPage * pageSize)
            .map((lead) => (
              <LeadCard
                individualSearch = {individualSearchTable || false}
                lead={lead}
                setSelectedRecord={setSelectedRecord}
                userPermissions={userPermissions}
                setApiResponse={setApiResponse}
                setModalLoading={setModalLoading}
                setIsModalVisible={setIsModalVisible}
                setIsTechModalVisible={setIsTechModalVisible}
                haveEnrichmentCredits={haveEnrichmentCredits}
                setDomainToEnrich={setDomainToEnrich}
                setEnrichmentModalVisible={setEnrichmentModalVisible}
                setLeadToDelete={setLeadToDelete}
                setIsDeleteModalVisible={setIsDeleteModalVisible}
                searchQuery={searchQuery}
                path = {path}
              />
            ))}

          <div style={{ display: 'flex', justifyContent: "center", marginTop: 20 }}>
            <Pagination
              current={actualPage}
              pageSize={pageSize}
              total={
                individualSearchTable 
                  ? individualSearchData?.length || 0 
                  : searchQuery.length ?
                    filteredData.length
                    :
                    resultData.length
              }
              onChange={(page, size) => {
                setActualPage(page);
                setPageSize(size);
                const start = (page - 1) * size;
                const end = start + size;
                const currentData = individualSearchTable
                  ? individualSearchData?.slice(start, end)
                  : resultData.slice(start, end);
                setActualPageSize(currentData.length);
              }}
              showSizeChanger={true}
              pageSizeOptions={['5', '10', '20', '50']}
            />
          </div>
        </div>
      </div>
    );
  };

  const handleClose = () => {
    setIsModalVisible(false);
    setApiResponse(null);
    setSelectedRecord(null);
  };

  return (
    <div className="main-container">
      {individualSearchTable ? (
        <></>
      ) : (
        <HeaderSection title={`Resultados`} apolloKey={apolloKey} subtitle={goBackButton()}/>
      )}
      {renderSection()}
      <TechModal
        setSelectedRecord={setSelectedRecord}
        selectedRecord={selectedRecord}
        setIsTechModalVisible={setIsTechModalVisible}
        isTechModalVisible={isTechModalVisible}
      />
      <CompanySumary 
        isModalVisible={isModalVisible} 
        handleClose={handleClose}
        modalLoading={modalLoading} 
        selectedRecord={selectedRecord} 
        apiResponse={apiResponse}/>

      <EnrichmentModal
        enrichmentModalVisible={enrichmentModalVisible}
        setEnrichmentModalVisible={setEnrichmentModalVisible}
        domainToEnrich={domainToEnrich}
        setDomainToEnrich={setDomainToEnrich}
        enrichmentQuantity={enrichmentQuantity}
        setEnrichmentQuantity={setEnrichmentQuantity}
        selectedLevels={selectedLevels}
        setSelectedLevels={setSelectedLevels}
        selectedRecord={selectedRecord}
        setSelectedRecord={setSelectedRecord}
        resultData={resultData}
        actualPage={actualPage}
        pageSize={pageSize}
        actualPageSize={actualPageSize}
        haveEnrichmentCredits={haveEnrichmentCredits}
        companyLoading={companyLoading}
        setCompanyLoading={setCompanyLoading}
        enrichAllResultsLoading={enrichAllResultsLoading}
        setEnrichAllResultsLoading={setEnrichAllResultsLoading}
        enrichingEmploee={enrichingEmploee}
        setEnrichingEmploee={setEnrichingEmploee}
        enrichmentResultKey={enrichmentResultKey}
        setEnrichMentResultKey={setEnrichMentResultKey}
        setApolloKey={setApolloKey}
        setRequestErichmentCredtisKey={setRequestErichmentCredtisKey}
        enrichPerson={enrichPerson}
      />

      <Modal title={`Enriquecer todas as pessoas da página atual ? Serão gastos ${pagePeopleCreditsCost} créditos`} visible={pagePeopleEnrichmentModalVisible} onCancel={()=>setPagePeopleEnrichimentModalVisible(false)} onOk={()=>{
        setEnrichPeopleLoading(true)
        setPagePeopleEnrichimentModalVisible(false)
        const idsEmpresa = new Set<string>();
        const idsPessoas = new Set<string>();
        const lowerIndex = (actualPage - 1) * pageSize;
        const upperIndex = lowerIndex + pageSize;
        const slice = resultData
        .slice(lowerIndex, upperIndex)
        .filter(
          (d): d is SearchResultData & { dados_empresa: unknown[] } =>
            Array.isArray(d.dados_empresa) && d.dados_empresa.length > 0
        );
        for (const item of slice) {
          if (item.dados_empresa) {
            for (const emp of item.dados_empresa) {
              idsEmpresa.add(emp.id);
            }
          }
          if (item.dados_pessoas) {
            for (const pes of item.dados_pessoas) {
              idsPessoas.add(pes.id);
            }
          }
        }
        
        const resultado: string[] = [];
        for (const id of idsEmpresa) {
          if (!idsPessoas.has(id)) {
            resultado.push(id);
          }
        }
                    
        if (resultado.length === 0) {
          message.error("Nenhuma empresa disponivel para enriquecimento");
          return;
        } else {
          enrichPerson(resultado);
        }
                    
      }}/>
      <Modal
        title="Confirmar Exclusão"
        visible={isDeleteModalVisible}
        onOk={() => {
          posthog.capture('lead_delete_modal_confirm');
          handleDeleteLead();
        }}
        onCancel={() => {
          posthog.capture('lead_delete_modal_cancel');
          setIsDeleteModalVisible(false)
        }}
        okText="Confirmar"
        okButtonProps={{ loading: deleteModalLoading, className:'submitButton' }}
        cancelButtonProps={{style:{display:'none'}}}
      >
        <p>Tem certeza que deseja excluir {leadToDelete?.razao_social ? leadToDelete.razao_social : formatCnpj(leadToDelete?.cnpj ?? '')} de {leadToDelete?.nome_lista}?</p>
      </Modal>
    </div>
  );
};

export default SearchResultsPage;
